import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";
import { faChevronDown } from "@fortawesome/pro-solid-svg-icons";
import { moveItemInArray } from "@angular/cdk/drag-drop";
import { AppService } from "src/app/app.service";
import { GridColumnNames } from "../pharma-page.model";

@Component({
  selector: "app-database-column-picker",
  templateUrl: "./database-column-picker.component.html",
  styleUrls: ["./database-column-picker.component.scss"],
})
export class DatabaseColumnPickerComponent implements OnInit, OnChanges {
  @Input() isVisible: boolean;
  @Input() columnList: Array<any>;
  @Output() onChange: EventEmitter<Array<string>> = new EventEmitter();

  items = [
    {
      id: 1,
      name: GridColumnNames.drug_name,
      columnKey: "drug_name",
      isSelected: true,
      isDisabled: false,
      isDraggable: false,
      isRemovable: false,
      index: 0,
    },
    {
      id: 2,
      name: GridColumnNames.ticker,
      columnKey: "ticker",
      isSelected: true,
      isDisabled: false,
      isDraggable: false,
      isRemovable: false,
      index: 1,
    },
    {
      id: 3,
      name: GridColumnNames.companyname,
      columnKey: "companyname",
      isSelected: false,
      isDisabled: false,
      isDraggable: false,
      isRemovable: true,
      index: 2,
    },
    {
      id: 4,
      name: GridColumnNames.indications,
      columnKey: "indications",
      isSelected: true,
      isDisabled: false,
      isDraggable: true,
      isRemovable: true,
      index: 2,
    },

    {
      id: 5,
      name: GridColumnNames.moa,
      columnKey: "moa",
      isSelected: true,
      isDisabled: false,
      isDraggable: true,
      isRemovable: true,

      index: 2,
    },
    {
      id: 6,
      name: GridColumnNames.target,
      columnKey: "target",
      isSelected: false,
      isDisabled: false,
      isDraggable: true,
      isRemovable: true,

      index: 2,
    },
    {
      id: 7,
      name: GridColumnNames.lines,
      columnKey: "lines",
      isSelected: true,
      isDisabled: false,
      isDraggable: true,
      isRemovable: true,
      index: 2,
    },
    {
      id: 8,
      name: GridColumnNames.commercial_status,
      columnKey: "commercial_status",
      isSelected: false,
      isDisabled: false,
      isDraggable: true,
      isRemovable: true,
      index: 2,
    },
    {
      id: 9,
      name: GridColumnNames.therapeutic_area,
      columnKey: "therapeutic_area",
      isSelected: false,
      isDisabled: false,
      isDraggable: true,
      isRemovable: true,

      index: 1,
    },
    {
      id: 10,
      name: GridColumnNames.probability_of_success_display,
      columnKey: "probability_of_success",
      isSelected: false,
      isDisabled: false,
      isDraggable: true,
      isRemovable: true,

      index: 1,
    },
    {
      id: 11,
      name: GridColumnNames.launch_year,
      columnKey: "launch_year",
      isSelected: false,
      isDisabled: false,
      isDraggable: true,
      isRemovable: true,

      index: 1,
    },
    {
      id: 12,
      name: GridColumnNames.approval_date,
      columnKey: "approval_date",
      isSelected: false,
      isDisabled: false,
      isDraggable: true,
      isRemovable: true,

      index: 1,
    },
    {
      id: 13,
      name: GridColumnNames.max_value,
      columnKey: "max_value",
      isSelected: false,
      isDisabled: false,
      isDraggable: true,
      isRemovable: true,

      index: 1,
    },
    {
      id: 14,
      name: GridColumnNames.max_year,
      columnKey: "max_year",
      isSelected: false,
      isDisabled: false,
      isDraggable: true,
      isRemovable: true,
      index: 1,
    },
    {
      id: 15,
      name: GridColumnNames.peak_value,
      columnKey: "peak_value",
      isSelected: false,
      isDisabled: false,
      isDraggable: true,
      isRemovable: true,

      index: 1,
    },
    {
      id: 16,
      name: GridColumnNames.peak_year,
      columnKey: "peak_year",
      isSelected: false,
      isDisabled: false,
      isDraggable: true,
      isRemovable: true,

      index: 1,
    },
    {
      id: 17,
      name: GridColumnNames.drug_type,
      columnKey: "drug_type",
      isSelected: false,
      isDisabled: false,
      isDraggable: true,
      isRemovable: true,

      index: 1,
    },
    {
      id: 18,
      name: GridColumnNames.drug_class,
      columnKey: "drug_class",
      isSelected: false,
      isDisabled: false,
      isDraggable: true,
      isRemovable: true,

      index: 1,
    },
    {
      id: 19,
      name: GridColumnNames.api,
      columnKey: "api",
      isSelected: false,
      isDisabled: false,
      isDraggable: true,
      isRemovable: true,

      index: 1,
    },
    {
      id: 20,
      name: GridColumnNames.delivery_mechanism,
      columnKey: "delivery_mechanism",
      isSelected: false,
      isDisabled: false,
      isDraggable: true,
      isRemovable: true,

      index: 1,
    },
    {
      id: 21,
      name: GridColumnNames.revenue_type,
      columnKey: "revenue_type",
      isSelected: false,
      isDisabled: false,
      isDraggable: true,
      isRemovable: true,

      index: 1,
    },
    {
      id: 22,
      name: GridColumnNames.originator_licensee,
      columnKey: "originator_licensee",
      isSelected: false,
      isDisabled: false,
      isDraggable: true,
      isRemovable: true,

      index: 1,
    },
    {
      id: 23,
      name: GridColumnNames.generic_biosimilar,
      columnKey: "generic_biosimilar",
      isSelected: false,
      isDisabled: false,
      isDraggable: true,
      isRemovable: true,

      index: 1,
    },
    {
      id: 24,
      name: GridColumnNames.alias_name,
      columnKey: "alias_name",
      isSelected: false,
      isDisabled: false,
      isDraggable: true,
      isRemovable: true,

      index: 1,
    },
    {
      id: 25,
      name: GridColumnNames.expiry_date,
      columnKey: "expiry_date",
      isSelected: false,
      isDisabled: false,
      isDraggable: true,
      isRemovable: true,

      index: 1,
    },
    {
      id: 26,
      name: GridColumnNames.dapparameter,
      columnKey: "dapparameter",
      isSelected: false,
      isDisabled: false,
      isDraggable: true,
      isRemovable: true,

      index: 1,
    },
    {
      id: 27,
      name: GridColumnNames.ctagid,
      columnKey: "ctagid",
      isSelected: false,
      isDisabled: false,
      isDraggable: true,
      isRemovable: true,

      index: 1,
    },
    {
      id: 28,
      name: GridColumnNames.aggregate_year_5,
      columnKey: "aggregate_year_5",
      isSelected: false,
      isDisabled: false,
      isDraggable: true,
      isRemovable: true,

      index: 1,
    },
    {
      id: 29,
      name: GridColumnNames.risk_type,
      columnKey: "risk_type",
      isSelected: false,
      isDisabled: false,
      isDraggable: true,
      isRemovable: true,
      index: 1,
    },
    {
      id: 30,
      name: GridColumnNames.geography,
      columnKey: "geography",
      isSelected: false,
      isDisabled: false,
      isDraggable: true,
      isRemovable: true,
      index: 1,
    },
    {
      id: 31,
      name: GridColumnNames.available_geography,
      columnKey: "available_geography",
      isSelected: false,
      isDisabled: false,
      isDraggable: true,
      isRemovable: true,
      index: 1,
    },
  ];
  currentItems = [];

  showIndicationBreakout = false;
  faChevronDown = faChevronDown;

  constructor(private appService: AppService) {}

  ngOnInit() {
    this.currentItems = this.appService.cloneArray(this.items);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.columnList && changes.columnList.currentValue) {
      const prevSet = new Set(changes.columnList.previousValue);
      const currentSet = new Set(changes.columnList.currentValue);
      if (
        (prevSet.has("risk_type") && currentSet.has("risk_type")) ||
        (!prevSet.has("risk_type") && !currentSet.has("risk_type"))
      ) {
        return; //no change in risk_type
      }
      this.currentItems = this.currentItems.map((cObj, index) => {
        const clone = JSON.parse(JSON.stringify(cObj));
        clone["index"] = index;
        if (changes.columnList.currentValue.indexOf(cObj.columnKey) !== -1) {
          clone["isSelected"] = true;
        }
        return {
          ...clone,
        };
      });
      this.items = this.appService.cloneArray(this.currentItems);
    }
  }

  onAddItem({ selectedItem, componentState }) {
    if (!selectedItem.isDisabled) {
      let finalSelectedItems = [];
      selectedItem.isSelected = true;
      if (selectedItem.id === 3) {
        const selectedItems = componentState.selectedItems;
        const firstTwoItems = (selectedItems as Array<any>).slice(0, 2);
        const restItems = (selectedItems as Array<any>).slice(2);
        finalSelectedItems = [...firstTwoItems, selectedItem, ...restItems];
      } else {
        finalSelectedItems = [...componentState.selectedItems, selectedItem];
      }
      this.currentItems = this.currentItems.map((item) => {
        const index = finalSelectedItems.findIndex(
          (sItem) => sItem.id === item.id,
        );
        item.index = index;
        if (index > -1) {
          item.isSelected = true;
        }
        return item;
      });
    }
  }

  onAddAllItems() {
    const firstTwoItems = [];
    let companyName = {};
    const restItems = [];
    this.currentItems.forEach((item) => {
      //Fixed items drug name and ticker
      if (item.id < 3) {
        firstTwoItems.push(item);
      } else if (item.id === 3) {
        companyName = item;
      } else {
        restItems.push(item);
      }
    });
    const finalSelectedItems = [
      ...firstTwoItems,
      companyName,
      ...restItems,
    ] as Array<any>;
    this.currentItems = this.currentItems.map((item) => {
      const index = finalSelectedItems.findIndex(
        (sItem) => sItem.id === item.id,
      );
      item.index = index;
      if (index > -1) {
        item.isSelected = true;
      }
      return item;
    });
  }

  onDragItem({ event, componentState }) {
    if (event.item.data.isDraggable && !event.item.data.isDisabled) {
      const selectedItems = componentState.selectedItems;
      const isCompanySelected =
        selectedItems.findIndex((item) => item.id === 3) > -1;
      let isCompanyDragged = false;
      if (isCompanySelected) {
        isCompanyDragged = selectedItems[event.previousIndex].id === 3;
        if (!isCompanyDragged) {
          if (event.currentIndex > 2) {
            moveItemInArray(
              selectedItems,
              event.previousIndex,
              event.currentIndex,
            );
            this.makeFreshItems(selectedItems);
          }
        }
      } else {
        if (event.currentIndex > 1) {
          moveItemInArray(
            selectedItems,
            event.previousIndex,
            event.currentIndex,
          );
          this.makeFreshItems(selectedItems);
        }
      }
    }
  }

  onRemoveItem({ removedItem }) {
    this.currentItems = this.currentItems.map((item) => {
      if (item.id === removedItem.id) {
        return {
          ...item,
          isSelected: false,
        };
      }
      return item;
    });
  }

  onRemoveAllItems() {
    this.currentItems = this.currentItems.map((item) => {
      if (item.isRemovable) {
        return {
          ...item,
          isSelected: false,
        };
      }
      return item;
    });
  }

  onApply({ selectedItems }) {
    this.items = this.appService.cloneArray(this.currentItems);
    this.onChange.emit(this.getColumnList(selectedItems));
    this.isVisible = false;
  }

  onCancel() {
    this.hideColumnPicker();
    this.currentItems = this.appService.cloneArray(this.items);
  }

  showColumnPicker() {
    this.isVisible = true;
  }

  hideColumnPicker() {
    this.isVisible = false;
  }

  makeFreshItems(selectedItems) {
    this.currentItems = this.currentItems.map((item) => {
      const index = selectedItems.findIndex((sItem) => sItem.id === item.id);
      item.index = index;
      return item;
    });
  }

  getColumnList(selectedItems) {
    const selectedCols = selectedItems.map((val) => val.columnKey);
    return selectedCols.filter((val) => {
      return val !== "drug_name" && val !== "ticker";
    });
  }
}
